import { toast } from 'sonner';
let isHandling401 = false;

export async function handle401() {
  if (typeof window === 'undefined') return;

  if (isHandling401) return;
  isHandling401 = true;

  try {
    await fetch('/api/auth/logout', {
      method: 'POST',
      credentials: 'include',
    });
  } catch (error) {
    console.error('Failed to clear auth session:', error);
  } finally {
    window.location.replace('/auth/login');
  }
}

export function handle401IgReauth() {
  if (typeof window === 'undefined') return;

  if (isHandling401) return;
  isHandling401 = true;

  toast.error('Session has been invalidated');

  // جلوگیری از لوپ ریدایرکت
  const targetRoute = '/dashboard/accounts';

  if (window.location.pathname !== targetRoute) {
    window.location.href = targetRoute;
  }
}